export const mapStyle = (state = 'light-v10', action) => {
  switch (action.type) {
    case 'SET_MAP_STYLE': {
      const { style } = action.payload;
      return style;
    }
    default:
      return state;
  }
};
